// extracted by mini-css-extract-plugin
module.exports = {"section14":"Section14_section14__KH9tX"};